module.exports = __webpack_public_path__ + "img/instagram.afac8448.png";